<script setup>
import { computed } from "vue";
import { InfoFilled } from "@element-plus/icons-vue";
import { readSysMsg } from "@/api/layout";
import { useMessageStore } from "@/stores/message";
import { useConfirm } from "@/composables/useFeedback";

const messageStore = useMessageStore();
const { alert } = useConfirm();

const sysMsg = computed(() => messageStore.sysMsg || {});
const dialogVisible = computed({
  get: () => !!sysMsg.value.dialog,
  set: (v) => {
    if (!v) messageStore.closeSysMsg();
  },
});

async function noted() {
  const remind = !!sysMsg.value.remind;
  try {
    const res = await readSysMsg(sysMsg.value.mid);
    messageStore.closeSysMsg();
    if (res?.data?.ErrorCode !== 0 && !remind) {
      await alert(res?.data?.Msg || "Failed", { type: "error" });
    }
  } catch (_) {
    messageStore.closeSysMsg();
  }
}
</script>

<template>
  <el-dialog
    v-model="dialogVisible"
    width="600px"
    align-center
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    class="system-msg-dialog"
  >
    <template #header>
      <div class="sys-title">{{ sysMsg.title }}</div>
    </template>
    <div class="system-content" v-html="sysMsg.content" />
    <template #footer>
      <div class="sys-actions">
        <el-button type="success" @click="noted">
          <el-icon class="mr"><InfoFilled /></el-icon>
          Noted
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">
.sys-title {
  font-size: 16px;
  font-weight: 600;
  color: #32397a;
}

.system-content {
  color: #32397a;
  line-height: 1.6;
  word-break: break-word;

  :deep(img) {
    max-width: 100%;
  }
}

.sys-actions {
  display: flex;
  justify-content: flex-end;

  .mr {
    margin-right: 4px;
  }
}
</style>
